import React, { useState, useEffect } from 'react';
import './History.css';
import apiClient from '../utils/apiClient';

const History = ({ onClose, idx, goMenu }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API에서 히스토리 데이터 가져오기
  useEffect(() => {
    const fetchHistoryData = async () => {
      if (!idx) {
        setError('잘못된 접근입니다.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await apiClient.post('/Customer/GetMarketingHistory', idx);

        if (response.data && response.success) {
          setHistoryData(response.data || []);
        } else if (response.data == "" && response.success) {
            setHistoryData([]);
        } else {
          setError(response.data?.message || '데이터를 불러오는데 실패했습니다.');
        }
      } catch (err) {
        console.error('히스토리 데이터 로드 실패:', err);
        setError('네트워크 오류가 발생했습니다.');
      } finally {
        setLoading(false);
      }
    };

    fetchHistoryData();
  }, [idx]);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // 오늘인지 확인
    if (date.toDateString() === today.toDateString()) {
      return '오늘';
    }
    
    // 어제인지 확인
    if (date.toDateString() === yesterday.toDateString()) {
      return '어제';
    }

    // 그 외의 경우 날짜 포맷팅
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'][date.getDay()];
    
    return `${year}년 ${month}월 ${day}일 (${dayOfWeek})`;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // 그 외의 경우 날짜 포맷팅
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    
    return `${hours}시 ${minutes}분 ${seconds}초`;
  };
  // 날짜별로 데이터 그룹화 및 정렬
  const groupedData = historyData.reduce((groups, item) => {
    const date = formatDate(item.regDate);
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(item);
    return groups;
  }, {});

  // 날짜를 최신순으로 정렬
  const sortedDates = Object.keys(groupedData).sort((a, b) => new Date(b) - new Date(a));

  // 날짜 포맷팅 함수
  

  const getTypeIcon = () => {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="m9 18 6-6-6-6"/>
      </svg>
    );
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'homepage':
        return '이미지';
      case 'place-ranking':
        return 'PR';
      case 'blog':
        return '문서';
      case 'instagram':
        return '테스트 로그';
      case 'video':
        return '관련 문서';
      default:
        return '기타';
    }
  };

  return (
    <div className="history-overlay">
      <div className="history-container">
        <div className="history-header">
          <h2>작업 히스토리</h2>
          <button className="close-button" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <div className="history-content">
          {loading ? (
            <div className="loading-state">
              <div className="loading-spinner">
                <div className="spinner"></div>
              </div>
              <p>히스토리를 불러오는 중...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <div className="error-icon">⚠️</div>
              <p>{error}</p>
              <button className="retry-button" onClick={() => window.location.reload()}>
                다시 시도
              </button>
            </div>
          ) : sortedDates.length > 0 ? (
            <div className="history-list">
              {sortedDates.map((date) => (
                <div key={date} className="date-group">
                  <div className="date-header">
                    <h3 className="date-title">{date}</h3>
                    <span className="item-count">{groupedData[date].length}개</span>
                  </div>
                  <div className="date-items">
                    {groupedData[date].map((item) => (
                      <div key={item.id} className="history-item">
                        <div className="history-item-content">
                          <div className="history-item-header">
                            <h4><b onClick={() => goMenu(item.id)}>{item.name}</b> 이(가) 추가되었습니다.</h4>
                            <span className="history-item-datetime">
                              {formatDateTime(item.regDate)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-history">
              <div className="empty-icon">📋</div>
              <p>아직 작업 히스토리가 없습니다.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default History;